import * as types from './actionTypes';

export const updateQRCodeHeaderText = headerText => ({
	type: types.UPDATE_QRCODE_HEADER_TEXT , payload: headerText
});